import {
  ref,
  reactive,
  computed,
  onBeforeMount,
  watch,
  getCurrentInstance,
  onMounted,
} from "@vue/composition-api";
import router from "@/router";
import useModal from "@/@core/components/base-modal/hooks/useModal";

export default function useQuestion(props) {
  const { openModal, closeModal } = useModal();

  const vm = getCurrentInstance().proxy;

  const activeIndex = ref(null);

  const activeHover = {
    SECTION_NAME: 1,
    SECTION_DESC: 2,
  };

  const formDataActive = reactive({
    activeName: null,
    activeDesc: null,
  });

  const activeEditor = reactive({
    questionName: null,
    Desc: null,
  });

  let countLength = null;

  const toggleActive = (type, section) => {
    setTimeout(() => {
      switch (type) {
        case activeHover.SECTION_NAME:
          formDataActive.activeName = section;
          formDataActive.activeDesc = null;

          break;
        case activeHover.SECTION_DESC:
          formDataActive.activeDesc = section;
          formDataActive.activeName = null;

          break;
        default:
          formDataActive.activeName = null;
          formDataActive.activeDesc = null;
      }
    }, 10);

    vm.$emit("set-active");
  };

  const unActiveQuestion = () => {
    activeEditor.questionName = false;
    activeEditor.Desc = false;
    vm.$emit("unActiveQuestion");
  };

  const componentData = reactive({
    type: "transition",
    name: "flip-list",
  });

  const customQuillOption = {
    theme: "snow",
    modules: {
      toolbar: {
        container: "#my-toolbar",
      },
      // "emoji-toolbar": true,
      // "emoji-textarea": true,
      // "emoji-shortname": true,
      keyboard: {
        bindings: {
          "list autofill": {
            prefix: /•\\s\\d\\.\\s[A-z]/,
          },
        },
      },
    },
  };

  const editorName = computed(() => vm.$refs.sectionNameQuill.quill);
  const editorDesc = computed(() => vm.$refs.quizDescQuill.quill);

  const onFocusInput = (editor) => {
    editorName.value.focus();
    if (editor == "sectionNameQuill") {
      editorName.value.focus();
    } else if (editor == "sectionDescQuill") {
      editorDesc.value.focus();
    }
  };

  const sectionActionListNoMerge = reactive({
    move: {
      label: "Move",
      value: 1,
      display: true,
    },
    delete: {
      label: "Delete",
      value: 2,
      display: true,
    },
    duplicate: {
      label: "Duplicate",
      value: 3,
      display: true,
    },
  });

  const sectionActionListNoMergeNoDelete = reactive({
    move: {
      label: "Move",
      value: 1,
      display: true,
    },

    duplicate: {
      label: "Duplicate",
      value: 3,
      display: true,
    },
  });

  const sectionActionList = reactive({
    move: {
      label: "Move",
      value: 1,
      display: true,
    },
    delete: {
      label: "Delete",
      value: 2,
      display: true,
    },
    duplicate: {
      label: "Duplicate",
      value: 3,
      display: true,
    },

    mergeSecction: {
      label: "Merge Section",
      value: 4,
      display: true,
    },
  });

  const questionAction = reactive({
    mergeSecction: {
      value: false,
      payload: null,
    },
  });

  const resolveActionList = (index) => {
    if (index == 0) {
      if (countLength > 1) {
        return sectionActionListNoMerge;
      } else {
        return sectionActionListNoMergeNoDelete;
      }
    } else {
      return sectionActionList;
    }
  };

  const resolveSectionAction = (type, sectionObj) => {
    switch (type) {
      case sectionActionList.move.value:
        vm.$emit("EditQuestion");
        modalType.isReoderSection = true;
        onOpenModalReorderSection();
        return;
      case sectionActionList.delete.value:
        let index = props.formQuestion.indexOf(sectionObj);
        vm.$emit("deleteSection", sectionObj.sectionId, index);
        return;
      case sectionActionList.duplicate.value:
        onDuplicateSection(sectionObj);
        return;
      case sectionActionList.mergeSecction.value:
        onMergeSection(sectionObj);
        return;
      default:
    }
  };

  const AddActionList = reactive({
    addQuestion: {
      label: "Add Question",
      value: 1,
      icon: "AddQuestionIcon",
      display: true,
    },
    addSection: {
      label: "Add Section",
      value: 2,
      icon: "AddSectionIcon",
      display: true,
    },
  });

  const resolveAddAction = (type, item) => {
    switch (type) {
      case AddActionList.addQuestion.value:
        onAddQuestion(item);
        return;
      case AddActionList.addSection.value:
        onAddSection(item);
        return;
      default:
    }
  };

  const modalType = reactive({
    isReoderSection: false,
  });

  const onOpenModalReorderSection = () => {
    modalType.isReoderSection = true;
    openModal();
  };

  const onCloseModalReorderSection = () => {
    closeModal();
    modalType.isReoderSection = false;
  };

  const onAddChoice = (question) => {
    vm.$emit("onAddChoice", question);
  };

  const onAddOther = (question) => {
    vm.$emit("onAddOther", question);
  };

  const onRemoveChoice = (index, choice, question) => {
    vm.$emit("onRemoveChoice", index, choice, question);
  };

  const onUploadImage = (image, formData) => {
    vm.$emit("onUploadImage", image, formData);
  };

  const onUploadImageChoice = (image, formData) => {
    vm.$emit("onUploadImageChoice", image, formData);
  };

  const onDuplicateSection = (element) => {
    const idx = props.formQuestion.indexOf(element);

    vm.$emit("onDuplicateSection", element, idx);
  };

  const onDuplicateQuestion = (questionObj, section) => {
    vm.$emit("onDuplicateQuestion", questionObj, section);
  };

  const onAddSection = (item) => {
    vm.$emit("onAddSection", item);
  };

  const onAddQuestion = (question) => {
    vm.$emit("onAddQuestion", question);
  };

  const onMergeSection = (element) => {
    questionAction.mergeSecction.value = true;

    let index = props.formQuestion.indexOf(element);

    questionAction.mergeSecction.payload = { element, index };
    vm.$emit("EditQuestion", false, true);
    // then emit mergeSection func
  };

  const onSaveReoder = (sectionMoveObj) => {
    onCloseModalReorderSection();
    vm.$emit("onSaveReoder", sectionMoveObj);
  };

  const hoverQestionId = ref(null);

  const onHover = (index, hover) => {
    hoverQestionId.value = hover ? index : null;
  };

  onBeforeMount(() => {
    countLength = props.formQuestion.length;
  });

  watch(
    () => props,
    () => {
      countLength = props.formQuestion.length;
    },
    { deep: true }
  );

  watch(
    // for merge function
    [() => questionAction.mergeSecction.value, () => props.isEditForm],
    () => {
      if (questionAction.mergeSecction.value && props.isEditForm) {
        vm.$emit(
          "onMergeSection",
          questionAction.mergeSecction.payload.element.sectionId,
          props.formQuestion[questionAction.mergeSecction.payload.index - 1]
            .sectionId
        );
        // set questionAction default value
        questionAction.mergeSecction.value = false;
        questionAction.mergeSecction.payload = null;
      }
    },
    {
      deep: true,
    }
  );

  return {
    toggleActive,
    activeHover,
    customQuillOption,
    onFocusInput,
    componentData,
    activeIndex,
    unActiveQuestion,
    resolveSectionAction,
    sectionActionList,
    AddActionList,
    resolveAddAction,
    modalType,
    onOpenModalReorderSection,
    onCloseModalReorderSection,
    onAddChoice,
    onAddOther,
    onRemoveChoice,
    onUploadImage,
    onUploadImageChoice,
    formDataActive,
    onDuplicateSection,
    onDuplicateQuestion,
    onAddSection,
    onAddQuestion,
    onSaveReoder,
    resolveActionList,
    hoverQestionId,
    onHover,
    activeEditor,
  };
}
